import axios from "@/utils/axios";
import { GetCurrentUserResponse } from "@/api/users/get-current-user.response";
import { Guid } from "@/domain/guid";
import { GetCurrentUserCharactersResponse } from "@/api/users/get-current-user-characters.response";

export interface EditCharacterKeystonesDataRequestModel {
	id: string;
	keystoneID: number | null;
	keystoneLevel: number | null;
}

export default {
	async getCharacters(): Promise<GetCurrentUserCharactersResponse> {
		return (await axios().get("/users/characters/")).data;
	},
	async getDetails(): Promise<GetCurrentUserResponse> {
		return (await axios().get("/users/current/")).data;
	},
	async syncCharacters(): Promise<void> {
		return (await axios().put("/users/characters/sync/")).data;
	},
	async editCharactersKeystones(payload: EditCharacterKeystonesDataRequestModel[]): Promise<void> {
		return (await axios().put("/users/current/characters/keystones/", payload)).data;
	},
	async getCharacterToClaim(): Promise<any[] | null> {
		return (await axios().get("/users/claim/")).data;
	},
	async claimCharacter(region: string, realm: string, name: string): Promise<void> {
		return (await axios().post(`/users/claim/${region}/${realm}/${name}/`)).data;
	},
	async getCharactersToTransferTo(characterID: Guid): Promise<any[] | null> { // Not used
		return (await axios().get(`/users/transfer/${characterID}`)).data;
	},
	async transferCharacter(characterID: Guid, name: string, realm: string): Promise<any> {
		return (await axios().post(`/users/transfer/${characterID}/${name}/${realm}`)).data;
	},
	async deleteCharacter(characterID: Guid) {
		return (await axios().delete(`/users/characters/${characterID}`)).data;
	},
	async toggleCharacterVisibility(characterID: Guid) {
		return (await axios().patch(`/users/characters/${characterID}/toggleVisibility`)).data;
	},
	async changeCharacterOrder(characterID: Guid, newPosition: number) {
		return (await axios().patch(`/users/characters/${characterID}/changeOrder`, {newPosition: newPosition})).data;
	},
	async changeTeamOrder(teamID: Guid, newPosition: number) {
		return (await axios().patch(`/users/teams/${teamID}/changeOrder`, {newPosition: newPosition})).data;
	},

	// Teams contributions
	async getMyTeamsContributions(): Promise<any> {
		return (await axios().get("/users/current/teams-contributions/")).data;
	},
	async getMyTeamContributions(teamID: Guid): Promise<any> {
		return (await axios().get(`/users/current/teams-contributions/${teamID}`)).data;
	},
	async addContributionToTeam(teamID: Guid): Promise<void> {
		return (await axios().patch(`/users/current/teams-contributions/${teamID}/add`)).data;
	},
	async removeContributionToTeam(teamID: Guid): Promise<void> {
		return (await axios().patch(`/users/current/teams-contributions/${teamID}/remove`)).data;
	},
};
